import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import axios from "./axios";

const firebaseConfig = {
    apiKey: "AIzaSyAjbPgMD4fRfkhQN8w9l3q6rErQQjgtTI8",
    authDomain: "risman-53b90.firebaseapp.com",
    projectId: "risman-53b90",
    storageBucket: "risman-53b90.appspot.com",
    messagingSenderId: "940876830031",
    appId: "1:940876830031:web:d49b78cd16d3b87f6b213a",
    measurementId: "G-5KHVJ55SZN"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const requestForToken = (saveToken) => {
    return getToken(messaging, {vapidKey: 'BAjdstV_gwkIsxlCv_EZBwW2LwpqUjogCiDHoDejY2Eh0LMvqa_DNFYz4ainyn_lVevICw4gY4i8rzSFCrhBdOY'}).then((currentToken) => {
        if (currentToken) {
            console.log('current token for client: ', currentToken);
            saveToken(currentToken)
            // Track the token -> client mapping, by sending to backend server
            // show on the UI that permission is secured
        } else {
            console.log('No registration token available. Request permission to generate one.');
            // shows on the UI that permission is required
        }
    }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
        // catch error while creating client token
    });
}

export const onMessageListener = () =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            console.log("payload", payload)
            resolve(payload);
        });
    });